import React, { memo } from 'react'

import { ExpressCheckoutElement } from '@stripe/react-stripe-js'
import { StripeExpressCheckoutElementOptions } from '@stripe/stripe-js'
import { useWatch } from 'react-hook-form'

import useEvent from 'Hooks/useEvent'
import { PaymentMethods } from 'Types'

import { usePayment } from '../../PaymentArea/Provider'

const options: StripeExpressCheckoutElementOptions = {
  buttonType: {
    applePay: 'order',
    googlePay: 'order',
  },
  paymentMethods: {
    applePay: 'never',
    googlePay: 'never',
    amazonPay: 'never',
    link: 'never',
    paypal: 'never',
  },
}

interface Props {
  onSubmit(): void
}
const StripeBtn = ({ onSubmit }: Props) => {
  const { gateway } = usePayment()
  const { applePay, googlePay, field } = gateway
  const paymentMethod = useWatch({ name: `${field}.paymentMethod` }) as PaymentMethods

  const applePayOptions: StripeExpressCheckoutElementOptions = {
    ...options,
    paymentMethods: {
      ...options.paymentMethods,
      applePay: 'always',
    },
  }

  const googlePayOptions: StripeExpressCheckoutElementOptions = {
    ...options,
    paymentMethods: {
      ...options.paymentMethods,
      googlePay: 'always',
    },
  }

  const handleConfirm = useEvent(() => onSubmit())

  return (
    <>
      {applePay && paymentMethod == PaymentMethods.APPLE_PAY ? (
        <ExpressCheckoutElement options={applePayOptions} onConfirm={handleConfirm} />
      ) : null}
      {googlePay && paymentMethod == PaymentMethods.GOOGLE_PAY ? (
        <ExpressCheckoutElement options={googlePayOptions} onConfirm={handleConfirm} />
      ) : null}
    </>
  )
}

export default memo(StripeBtn)
